// extracted by mini-css-extract-plugin
module.exports = {"aktuelleMalgrupper":"AktuelleMalgrupper_aktuelleMalgrupper__NRD1O","text":"AktuelleMalgrupper_text__rJuqJ"};